import { render } from "./Candidate.small-card.vue?vue&type=template&id=335eaa68"
import script from "./Candidate.small-card.vue?vue&type=script&lang=js"
export * from "./Candidate.small-card.vue?vue&type=script&lang=js"

import "./Candidate.small-card.vue?vue&type=style&index=0&id=335eaa68&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
